/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'wouter';

import Image from '../partials/Image';
import Text from '../typography/Text';
import Title from '../typography/Title';

import styles from '../../../styles/cards/selection.module.css';

const propTypes = {
    item: PropTypes.shape({}),
    className: PropTypes.string,
};

function SelectionCard({ item = null, className = null, ...props }) {
    const { title = null, startDate = null, endDate = null, image = null, url = null } = item || {};

    return (
        <Link
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            href={url}
            {...props}
        >
            {image !== null ? (
                <Image
                    className={styles.image}
                    image={image}
                    size="medium"
                    filtered
                    rounded
                    square
                />
            ) : null}
            <div className={styles.content}>
                <Title className={styles.title} size="small">
                    {title}
                </Title>
                <Text className={styles.dates}>
                    {startDate !== null ? startDate : null}
                    {endDate !== null ? `, ${endDate}` : null}
                </Text>
            </div>
        </Link>
    );
}

SelectionCard.propTypes = propTypes;

export default SelectionCard;
